import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomPage from "components/CustomPage";
import { useEffect, useState } from "react";
import { apiUrl } from "config/settings";
import { useDispatch, useSelector } from "react-redux";
import http from "http";
import Details from "./Details";
import CustomButton from "components/CustomButton";
import NullCheck from "components/NullCheck";
import useDataManager from "hooks/useDataManager";
import { ROLES_ID } from "config/roles";
import { setDeleteMassage, setShowLoading, setShowMassage } from "store/sysSlice";
import { Stack } from "@mui/material";
import { endpointName } from "./const";
import { calculateConsumption } from "config/functions";
import TableData from "./TableData";
import Header from "./Header";

const MeterRead = () => {
  const { removeItem } = useDataManager();
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const userRole = useSelector((state) => state.userSettings?.user?.userRole);
  const [meterDetails, setMeterDetails] = useState(null);
  const [list, setList] = useState([]);
  const [data, setData] = useState([]);
  const [metersList, setMetersList] = useState([]);

  useEffect(() => {
    getData()
    getMeters()
  }, [])

  useEffect(() => {
    if (list.length > 0 && metersList.length > 0) {
      let newList = list?.filter(item => item?.meter?._id === metersList[0]._id)
      setData(calculateConsumption(newList));
    }
  }, [list, metersList])

  useEffect(() => {
    /** if Role Is Employees Open Create Meter Read  */
    if (metersList?.length > 0 && userRole === ROLES_ID.EMPLOYEE)
      meterReadDetailsHandle({ id: "new" })
  }, [userRole, metersList])

  const meterReadDetailsHandle = (item) => {
    if (metersList.length === 0)
      dispatch(setShowMassage({ massage: "THERE_ARE_NO_METERS", type: "error" }));

    else
      setMeterDetails(item);
  };

  const deleteItem = (id) => {
    dispatch(
      setDeleteMassage({
        massage: "DELETE_METER_READ",
        onClick: () => {
          dispatch(setShowLoading(true));
          http
            .delete(`${apiUrl}/${endpointName}/${id}`)
            .then((res) => {
              dispatch(setShowLoading(false));
              const newList = removeItem(id, list);
              dispatch(setList(newList))
            })
            .catch((error) => {
              dispatch(setShowLoading(false));
            });
        },
      })
    );
  };

  const getData = () => {
    dispatch(setShowLoading(true));
    http.get(`${apiUrl}/${endpointName}`).then((res) => {
      setList(calculateConsumption(res?.data?.data));
      dispatch(setShowLoading(false));
    });
  };

  const getMeters = () => {
    dispatch(setShowLoading(true));
    http.get(`${apiUrl}/meter`).then((res) => {
      setMetersList(res?.data?.data?.filter(m => m?.isActive));
      dispatch(setShowLoading(false));
    });
  };

  const createMeterRead = () => {
    meterReadDetailsHandle({ id: "new" })
  }

  return (
    <CustomPage
      header={
        userRole !== ROLES_ID.EMPLOYEE
          ? <Header
            createMeterRead={createMeterRead}
            list={list}
            setData={setData}
          />
          : null
      }>

      {userRole === ROLES_ID.EMPLOYEE
        ? <Stack height='100%' justifyContent='center' alignItems='center'>
          <CustomButton height={50} title='CREATE_METER_READ' onClick={createMeterRead} />
        </Stack>
        : <TableData
          data={data}
          deleteItem={deleteItem}
          setMeterDetails={setMeterDetails}
        />
      }

      <NullCheck valueForCheck={meterDetails}>
        <Details
          data={meterDetails}
          setData={setMeterDetails}
          metersList={metersList}
          list={list}
          setList={setList}
        />
      </NullCheck>
    </CustomPage>
  );
};
export default MeterRead;
